export default __webpack_public_path__ + "static/media/METIS.21685540.svg";